export function createColumnDataSet(data) {
  return data.map(([label, value = 'N/A']) => [label, value]);
}
